import { Box } from "@mui/material";

import { useContext, useEffect, useState } from "react";
import { UBAppModal } from "../../../../Libraries";
import { UBAppTabs } from "../../../common";

import { LanguageContext } from "../../../../context/LanguageContext";
import FilterTabContent from "./FIlterTabContent";
import SortTabContent from "./SortTabContent";
import {
  DateFilter,
  SortFilter,
  SortWithoutAmountFilter,
  TransactionFilter,
} from "../../../../constants";
import { useSnackbar } from "../../../../context/SnackbarContext";

export const initialFilters = {
  dateType: DateFilter[0],
  transaction: TransactionFilter[0],
  sort: SortFilter[0],
  startDate: null,
  endDate: null,
};
const FilterModal = ({
  isOpen = false,
  handleClose,
  setFilters = () => {},
  filter,
  isReportListing,
  isCustomerSupplierReportListing,
  filterTab,
  handleFilterLogEvent = () => {},
  handleSortLogEvent = () => {},
  handleClearLogEvent = () => {},
  sortTab,
}) => {
  const { showSnackbar } = useSnackbar();

  const [filterOp, setFilterOp] = useState(initialFilters);
  const [I18n] = useContext(LanguageContext);
  const [tabValue, setTabVal] = useState("filter");

  const onChangeTab = (event, newValue) => {
    setTabVal(newValue);
  };

  const handleClear = () => {
    handleClearLogEvent();
    setFilterOp({
      ...initialFilters,
    });
    setFilters({ ...initialFilters });
    handleClose();
  };
  useEffect(() => {
    if (filter) {
      setFilterOp({
        ...filter,
        startDate: filter.dateType === "Custom" ? filter.startDate : null,
        endDate: filter.dateType === "Custom" ? filter.endDate : null,
      });
    }
  }, [filter, isOpen]);

  return (
    <UBAppModal
      id="account_filter_modal"
      size={"lg"}
      open={isOpen}
      handleClose={handleClose}
      className={"filterModal AccountFilter"}
      header={{
        CustomHeader: <></>,
        handleClose: () => {
          handleClose();
        },
      }}
      footer={[
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer clear-btn`,
            title: `${I18n.clear} ${I18n.filter}`,
            onClick: () => handleClear(),
            id: "account_clear_filter",
          },
        },
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer apply-btn`,
            title: I18n.apply,
            id: "account_apply_filter",
            onClick: () => {
              if (
                filterOp.dateType === "Custom" &&
                !filterOp.startDate &&
                !filterOp.endDate
              ) {
                showSnackbar({
                  message: I18n.please_select_start_end_date,
                  severity: "error",
                  icon: "",
                });
                return;
              }
              if (filterOp.transaction != filter.transaction) {
                handleFilterLogEvent();
              }
              if (filterOp.sort != filter.sort) {
                handleSortLogEvent();
              }

              setFilters({ ...filterOp });
              handleClose();
            },
          },
        },
      ]}
    >
      <Box className="accountFilterModalBody">
        <UBAppTabs
          tabList={[
            { label: "filter", value: "filter" },
            { label: "sort", value: "sort" },
          ]}
          value={tabValue}
          handleChange={onChangeTab}
          variant="fullWidth"
        />
        <Box
          className={`accountFilterModalTabBody ${
            tabValue === "sort" ? "sortTabBody" : ""
          }`}
        >
          {tabValue === "filter" && (
            <FilterTabContent
              transactionFilter={
                filterTab
                  ? filterTab
                  : !isReportListing
                    ? TransactionFilter
                    : []
              }
              DateFilter={DateFilter}
              filterOp={filterOp}
              setFilterOp={setFilterOp}
            />
          )}
          {tabValue === "sort" && (
            <SortTabContent
              dateFilter={
                isCustomerSupplierReportListing
                  ? SortWithoutAmountFilter
                  : sortTab || SortFilter
              }
              filterOp={filterOp}
              setFilterOp={setFilterOp}
            />
          )}
        </Box>
      </Box>
    </UBAppModal>
  );
};

export default FilterModal;
